import { useEffect, useState } from 'react';

import { useMutation } from '@apollo/react-hooks';
import { ApolloClient } from 'apollo-boost';
import { format } from 'date-fns';
import { useHistory } from 'react-router-dom';

import { loginUserMutation, LoginUserMutationType } from 'pages/Login/query';
import { MutationObterTokenArgs } from 'types/graphql';
import { useIsLoggedIn } from 'utils/useInLoggedIn';

export interface InterfaceFormValues {
  username: string;
  password: string;
}

const USER_DEV = {
  username: 'antonio@klutch.com.br',
  password: 'tonho@sgi23',
};

export function useAuth(client: ApolloClient<object>, shouldRemember: boolean) {
  const history = useHistory();
  const isLogged = useIsLoggedIn();
  const [userSaved, setUserSaved] = useState<Partial<InterfaceFormValues>>({} as InterfaceFormValues);
  const defaultValues: Partial<InterfaceFormValues> = process.env.NODE_ENV !== 'production' ? userSaved : userSaved;
  const getRememberValue = localStorage.getItem('should_remember');

  const [login, { loading, error }] = useMutation<LoginUserMutationType, MutationObterTokenArgs>(loginUserMutation, {
    onCompleted({ obterToken }) {
      const storage = 'localStorage';
      window[storage].setItem('token', obterToken?.token as string);
      window[storage].setItem('should_remember', String(shouldRemember));
      window[storage].setItem('logged_time', format(new Date(), 'MM/dd/yyyy'));
      window[storage].setItem('employee', JSON.stringify(obterToken?.funcionario));
      client.writeData({ data: { isLoggedIn: true, employee: obterToken?.funcionario } });
    },
  });

  function onSaveLocalStorage(props: InterfaceFormValues) {
    if (!shouldRemember) {
      localStorage.removeItem('@user-saved');

      return;
    }

    const dataFormatted = JSON.stringify(props);

    localStorage.setItem('@user-saved', dataFormatted);

    return;
  }

  useEffect(() => {
    const data = localStorage.getItem('@user-saved');

    if (!data || !getRememberValue) {
      console.log('Sem data');
      setUserSaved({ ...defaultValues });
      return;
    }

    const rememberValueFormatted = JSON.parse(getRememberValue) as boolean;

    if (!rememberValueFormatted) {
      return;
    }

    const dataFormatted = JSON.parse(data) as InterfaceFormValues;

    setUserSaved({ ...dataFormatted });
  }, []);

  useEffect(() => {
    if (isLogged) {
      history.push('/dashboard');
    }
  }, [isLogged, history]);

  console.table(defaultValues);
  console.table(userSaved);

  return {
    login,
    defaultValues,
    getRememberValue,
    onSaveLocalStorage,
    loading,
    error,
  };
}
